import { Component, inject, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatCardTitle } from '@angular/material/card';
import { MatButton } from '@angular/material/button';
import { OrdersService } from '../../../../services/orders.service';
import { LoaderComponent } from '../../../loader/loader.component';
import { OfflineService } from '../../../offline/offline.service';
import { MessageService } from '../../../../services/message.service';
import { AuthService } from '../../../auth/auth.service';
import { Order } from '../../../../classes/order.class';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-form-checkout-payment',
    standalone: true,
    imports: [
        LoaderComponent,
        MatDialogContent,
        MatCardTitle,
        MatButton,
        MatIcon
    ],
    templateUrl: './form-checkout-payment.component.html',
    styleUrl: './form-checkout-payment.component.scss'
})
export class FormCheckoutPaymentComponent implements OnInit {
    ordersService = inject(OrdersService);
    loading = signal(false);
    works: string[] = [];
    readonly dialogRef = inject(MatDialogRef<FormCheckoutPaymentComponent>);
    public order: Order = inject(MAT_DIALOG_DATA);
    private offlineService = inject(OfflineService);
    private messageService = inject(MessageService);
    protected authService = inject(AuthService);

    ngOnInit(): void {
        this.works = this.order.data.orderPrices.map((item, i) => {
            const equipment = item.item?.name ? `Оборудование:${item.item?.name}` : '';
            return`${i + 1}.Работа:${item.price.work.name} ${item.price.category.name}
            ${equipment} Количество:${item.quantity};`;
        });
    }

    sendToPaymentDevice(): void {
        if (this.offlineService.offline()) {
            this.messageService.errorMessage('Отсутствует подключение к интернету');
            return;
        }

        this.loading.set(true);

        this.ordersService.aqsiOrder(this.order.data.id).subscribe({
            next: () => {
                this.messageService.successMessage('Данные были отправлены на кассу');
            },
            error: (error) => {
                this.messageService.errorMessage(error.message);
            }
        }).add(() => this.loading.set(false));
    }

    get enablePaymentDevice(): boolean {
        return !!this.authService.user().data?.company.settings?.paymentDevice &&
            !!this.authService.user().data?.paymentDevice?.serialNumber;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onAccept(): void {
        this.dialogRef.close(true);
    }

    get totalPrice(): number {
        return this.order.totalCost(this.order.orderPrice() || [], !!this.order.data.discount);
    }
}
